<div fxLayout="column" id="entity-table-component" class="material mat-card mat-card-table" [class.is-empty]="isTableEmpty">

  <ng-container>

    <!-- BATCH OPERATIONS START -->
    <div
      *ngIf="conf && selection.selected.length > 0"
      fxLayout="row wrap"
      fxLayoutAlign="start center"
      class="multiActionsButton fn-toolbar"
      [ngClass]="{'icons-only': multiActionsIconsOnly}"
      [style.display]="selection.selected.length > 0 ? 'block' : 'none'"
    >
      <div fxFlex="100%">
        <div *ngIf="conf.multiActions.length > 0 && !multiActionsIconsOnly" class="multiactions-title">
          <strong>{{"Batch Operations" | translate}}</strong>
        </div>
        <!-- -->
        <div *ngIf="conf.multiActions && conf.multiActions.length > 0" fxLayout="row wrap" fxLayoutGap="16px">
          <span *ngFor="let maction of conf.multiActions" ix-auto ix-auto-type="button" ix-auto-identifier="{{maction?.id}}">
            <!-- DEFAULT -->
            <ng-container *ngIf="!multiActionsIconsOnly">
              <button id="{{ maction?.id }}" mat-button *ngIf="maction.enable" (click)="maction.onClick(this.selection.selected);">
                <mat-icon>{{ maction?.icon }}</mat-icon>&nbsp;<span>{{maction?.label | translate}}</span>
              </button>
            </ng-container>

            <!-- ICONS ONLY -->
            <ng-container *ngIf="multiActionsIconsOnly">
              <button
                *ngIf="maction.enable"
                id="{{ maction?.id }}"
                mat-button matTooltip="{{ maction?.label  | translate }}"
                [matTooltipPosition]="maction?.ttpos"
                (click)="maction.onClick(this.selection.selected);"
              >
                <mat-icon>{{ maction?.icon }}</mat-icon>
              </button>
            </ng-container>

          </span> &nbsp;
        </div>

        <div *ngIf="!conf.multiActions || conf.multiActions.length == 0">
          <span ix-auto ix-auto-type="button" ix-auto-identifier="mdelete">
            <!-- With Labels -->
            <ng-container>
              <button mat-button (click)="doMultiDelete(this.selection.selected);">
                <mat-icon>delete</mat-icon><br><span>{{"Delete" | translate}}</span>
              </button>
            </ng-container>

            <!-- Without Labels -->
            <ng-container>
              <button (click)="doMultiDelete(this.selection.selected);" mat-button
              matTooltip="{{ 'Delete selections' | translate }}" matTooltipPosition="below">
                <mat-icon>delete</mat-icon>
              </button>
            </ng-container>
          </span >
        </div>

      </div>
    </div>
    <!-- BATCH OPERATIONS END -->

    <div class="table-container">
      <table
        *ngIf="conf && currentColumns && currentColumns.length > 0 && dataSource"
        multiTemplateDataRows
        mat-table
        matSort
        [dataSource]="dataSource"
        [style.minWidth.px]="displayedColumns.length * 25"
        #newEntityTable
      >
        <ng-container *ngFor="let column of columnsProps; let i = index;">

          <!-- Column Template -->
          <ng-container
            *ngIf="isBasicColumnTemplate(column)"
            [sticky]="isLeftStickyColumnNo(i)"
            matColumnDef="{{column}}"
          >
            <th [ngClass]="{'sticky-left-offset': shouldApplyStickyOffset(i), 'sticky-border-right': isLeftStickyColumnNo(i) && isTableOverflow()}" class="data-column" mat-header-cell *matHeaderCellDef>{{ currentColumns[i].name | translate }}</th>
            <td [ngClass]="{'sticky-left-offset': shouldApplyStickyOffset(i), 'sticky-border-right': isLeftStickyColumnNo(i) && isTableOverflow()}" [ngStyle]="{'cursor': (checkLength() && !conf.onRowClick) ? 'auto' : 'pointer'}" class="data-column" (mouseover)="onHover($event, true)" (mouseout)="onHover($event, false)" mat-cell *matCellDef="let element">
              <div class="text-overflow-ellipsis" [matTooltip]="currentColumns[i].enableMatTooltip ? element[column] : null">{{element[column]}}</div>
            </td>
          </ng-container>

          <!-- Expansion Chevrons -->
          <ng-container *ngIf="column == 'expansion-chevrons'" matColumnDef="{{column}}" stickyEnd>
            <th class="expansion-chevrons-column" [ngClass]="{'sticky-border-left': isTableOverflow()}" mat-header-cell *matHeaderCellDef></th>
            <td class="expansion-chevrons-column" (mouseover)="onHover($event, true)" (mouseout)="onHover($event, false)" [ngClass]="{'sticky-border-left': isTableOverflow()}" mat-cell *matCellDef="let element">
              <ng-container *ngIf="hasDetails() === true">
                <ng-container *ngIf="element === expandedElement">
                  <mat-icon role="img" fontSet="mdi-set" fontIcon="mdi-chevron-up" (mouseover)="onHover($event,true)" (mouseout)="onHover($event,false)"></mat-icon>
                </ng-container>
                <ng-container *ngIf="element !== expandedElement">
                  <mat-icon role="img" fontSet="mdi-set" fontIcon="mdi-chevron-down" (mouseover)="onHover($event, true)" (mouseout)="onHover($event, false)"></mat-icon>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>

          <!-- Threedot Actions -->
          <ng-container *ngIf="column == 'action'" matColumnDef="{{column}}" stickyEnd>
            <th class="threedot-column" [ngClass]="{'sticky-border-left': isTableOverflow()}" mat-header-cell *matHeaderCellDef></th>
            <td class="threedot-column" (mouseover)="onHover($event, true)" (mouseout)="onHover($event, false)"
            [ngClass]="{'sticky-border-left': isTableOverflow()}" mat-cell *matCellDef="let element">
              <app-entity-table-actions [entity]="this" [row]="element" (mouseover)="onHover($event, true)" (mouseout)="onHover($event, false)">
              </app-entity-table-actions>
            </td>
          </ng-container>

          <!-- Multiselect Checkboxes -->
          <ng-container *ngIf="column == 'multiselect'" matColumnDef="{{column}}" sticky>
            <th class="multiselect-column" mat-header-cell *matHeaderCellDef>
              <mat-checkbox
              [indeterminate]="selection.hasValue() && !isAllSelected"
              [checked]="selection.hasValue() && isAllSelected"
              color="primary"
              (change)="masterToggle($event)"
              ix-auto ix-auto-type="checkbox" ix-auto-identifier="title">
              </mat-checkbox>
            </th>
            <td class="multiselect-column" (mouseover)="onHover($event, true)" (mouseout)="onHover($event, false)"  [ngStyle]="{'cursor': checkLength() ? 'auto' : 'pointer'}" mat-cell *matCellDef="let element">
              <mat-checkbox
              color="primary"
              (click)="$event.stopPropagation()"
              (change)="$event ? toggleSelection(element) : null"
              [checked]="selection.isSelected(element)"
              ix-auto ix-auto-type="checkbox"
              [ix-auto-identifier]="element[conf.rowIdentifier || 'name']">
              </mat-checkbox>
            </td>
          </ng-container>

          <!-- Interactive Toggle Column -->
          <ng-container *ngIf="column == 'state' && isInteractive(column)" matColumnDef="{{column}}">
            <th class="toggle-column" mat-header-cell *matHeaderCellDef>{{ currentColumns[i].name | translate }}</th>
            <td class="toggle-column" mat-cell *matCellDef="let element" (mouseover)="onHover($event, true)" (mouseout)="onHover($event, false)">
              <mat-spinner [diameter]='40' *ngIf="element['onChanging']; else actionButtons"></mat-spinner>
              <ng-template #actionButtons>
                <!-- Toggle -->
                <div class="clickable" *ngIf="currentColumns[i].toggle"
                id="overlay__{{element.name}}_Running"
                ix-auto ix-auto-type="overlay" [ix-auto-identifier]="column + element.name"
                (click)="$event.stopPropagation(); this.conf.onSliderChange(element)"
                matTooltip="{{element.state}}" matTooltipPosition="right">
                </div>

                <mat-slide-toggle *ngIf="currentColumns[i].toggle"
                [checked]="element[column] === EntityJobState.Running"
                id="slide-toggle__{{column}}_{{element.name}}"
                ix-auto ix-auto-type="slider" ix-auto-identifier="{{column}}__{{element.name}}">
                </mat-slide-toggle>

                <!-- Button -->
                <button mat-stroked-button *ngIf="currentColumns[i].button"
                [ngClass]="getButtonClass(element[column])"
                (click)="$event.stopPropagation(); this.conf.onButtonClick(element)"
                id="interactive-button_{{column}}_{{element.name}}"
                ix-auto ix-auto-type="slider" ix-auto-identifier="{{column}}__{{element.name}}">
                  {{element[column].state}}
                  <div class="label-warning-icon" *ngIf="element[column].warnings?.length > 0">
                    <mat-icon role="img" fontSet="mdi-set" fontIcon="mdi-alert"></mat-icon>
                  </div>
                </button>
              </ng-template>
            </td>
          </ng-container>

          <!-- Interactive Checkbox Column -->
          <ng-container *ngIf="['enabled', 'enable', 'autostart'].includes(column) && isInteractive(column)" matColumnDef="{{column}}">
            <th class="toggle-column" mat-header-cell *matHeaderCellDef>{{ currentColumns[i].name | translate }}</th>
            <td class="toggle-column" mat-cell *matCellDef="let element" (mouseover)="onHover($event, true)" (mouseout)="onHover($event, false)">
              <mat-checkbox
              color="primary"
              id="checkbox__{{element.name}}"
              class="checkbox"
              [(ngModel)]="element[column]"
              (change)="this.conf.onCheckboxChange(element)"
              (click)="$event.stopPropagation()"
              ix-auto ix-auto-type="checkbox" ix-auto-identifier="{{ column }}__{{ element.name}}"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container
            *ngIf="['path', 'paths'].includes(column) && isInteractive(column)"
            matColumnDef="{{column}}"
          >
            <th mat-header-cell *matHeaderCellDef>{{ currentColumns[i].name | translate }}</th>
            <td mat-cell *matCellDef="let element" (mouseover)="onHover($event, true)" (mouseout)="onHover($event, false)">
              <div class="path-locked-status">
                <div class="text-overflow-ellipsis">{{ element[column] }}</div>
                <mat-icon
                  *ngIf="element.locked"
                  [matTooltip]="'Dataset is currently locked' | translate"
                  class="append"
                >locked</mat-icon>
              </div>
            </td>
          </ng-container>

        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="currentColumns.length">
            <div [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
              <app-entity-table-row-details [config]="element" [parent]="this"></app-entity-table-row-details>
            </div>
          </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="columnsProps"></tr>
        <tr
          mat-row class="element-row"
          id="{{element[getFirstKey()]}}"
          ix-auto ix-auto-type="expander" ix-auto-identifier="{{element[getFirstKey()]}}"
          *matRowDef="let element; columns: columnsProps; let i = dataIndex;"
          (click)="doRowClick(element)"
          [ngClass]="{'expanded-row': expandedElement === element}"
        ></tr>

        <ng-container *ngIf="hasDetails() === true">
          <tr mat-row class="details-row" *matRowDef="let row; columns: ['expandedDetail'];"></tr>
        </ng-container>
      </table>
    </div>

    <mat-card-footer *ngIf="conf.config.paging">
      <mat-paginator
        (page)="pageChanged()"
        [pageIndex]="paginationPageIndex"
        [pageSize]="paginationPageSize"
        [pageSizeOptions]="paginationPageSizeOptions"
        [showFirstLastButtons]="paginationShowFirstLastButtons"
      ></mat-paginator>
    </mat-card-footer>
  </ng-container>
  <ng-container *ngIf="isTableEmpty">
    <div class="entity-empty-wrapper" fxFlex="100%" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="32px">
      <entity-empty [conf]="emptyTableConf"></entity-empty>
    </div>
  </ng-container>
</div>
